import { useContext, useMemo, useState } from 'react';
import { svgSprite } from '../../../../hybrid/wrappers';
import FormRadio from '../../../form/components/form-radio/FormRadioSwitcher/FormRadioSwitcher';
import css from './WalletsItem.module.scss';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
import { LangContext } from '../../../../common/decorators/Language';
import { navigateV2 } from '../../../../common/utils/router';
import classNames from 'classnames';
import T, { t } from '../../../../common/components/T';
import { checkVerification } from '../../../../common/utils/utils';
import VerifyModal from '../VerifyModal/VerifyModal';
import CurrencyItem from './components/CurrencyItem/CurrencyItem';

export default function WalletsItem({
    key,
    wallet,
    isLast,
    index,
    customCss,
    isWalletsPage,
    meta,
    radioSwitcher,
    setRadioSwitcher
}) {
    const { userToken, lang } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const { translation } = useContext(LangContext);
    const [verifyModal, showVerifyModal] = useState(false);

    // const secondCurrency = useMemo(() => {
    //     return currencies?.data?.find((curr) => curr.code === localization.currency);
    // }, [localization, currencies]);

    // дістаємо з балансу значення до і після точки
    const [number, remainder] = useMemo(() => {
        return wallet?.balance && typeof wallet?.balance === 'string' ? wallet?.balance?.split('.') : [0, '00'];
    }, [wallet]);

    // фільтруємо валюти по кодам (для віджета лише ці 2 треба)
    // const filteredCurrencies = useMemo(() => {
    //     const defaultCurrency = { symbol: 'PV', code: 'PV' };
    //     return [defaultCurrency, secondCurrency];
    // }, [secondCurrency]);

    // перетворюємо валюти в опції для RadioSwitcher-а
    const currenciesAsOptions = useMemo(() => {
        return {
            1: 'PV',
            2: <div className={css.currenciesIcon}>{svgSprite('currencies')}</div>
        };
    }, []);

    // // хендлер для зміни валюти в віджеті (змінюємо стейт нової валюти - йде запит на нові акаунти)
    // const currencyHandler = (key, val) => {
    //     let newFindedCurrency = filteredCurrencies[val - 1];
    //     if (val === 1) {
    //         setNewFindedCurrency(false);
    //     } else if (newFindedCurrency) {
    //         setNewFindedCurrency(newFindedCurrency.code);
    //     }
    // };

    const outMoneyHandler = (e, currency_account) => {
        e.stopPropagation();
        checkVerification(
            userToken,
            lang,
            () => {
                let endOfUrl = '';
                if (currency_account) {
                    endOfUrl = `/${wallet.id}?ca=${currency_account?.id}`;
                } else {
                    endOfUrl = `/${wallet.id}`;
                }
                navigateV2(`/wallets/outmoney${endOfUrl}`);
            },
            () => showVerifyModal(true)
        );
    };

    const number_of_buttons = useMemo(() => {
        let num = 0;
        if (wallet.replenishment) num += 1;
        if (wallet.withdrawal) num += 1;
        if (wallet.transfer_to_user || wallet?.own_transfer_accounts?.length) num += 1;
        return num;
    }, [wallet]);

    // для кабінету фільтруємо по валюті юзера
    const filteredCurrencyAccounts = useMemo(() => {
        if (isWalletsPage) {
            const filterFunc = (currency_acc) => {
                if (currency_acc?.accountCurrency?.id === profileData?.currency?.id) return true;
                return +currency_acc?.balance;
            };
            if (profileData?.currency?.id) {
                return wallet?.currency_accounts
                    ?.sort((a) => {
                        return a?.accountCurrency?.id === profileData?.currency?.id ? -1 : 1;
                    })
                    ?.filter(filterFunc);
            }
            return wallet?.currency_accounts?.filter(filterFunc);
        } else {
            if (profileData?.currency?.id) {
                return wallet?.currency_accounts?.filter((account) => {
                    return account?.accountCurrency?.id === profileData?.currency?.id;
                });
            }
            return wallet?.currency_accounts;
        }
    }, [wallet, profileData, isWalletsPage]);

    return (
        <>
            <div key={key} className={css.wallet}>
                <div className={css.walletHead}>
                    <div className={css.walletNameBlock}>
                        <div className={css.walletNameBlockIcon}>
                            {svgSprite(`${wallet.purpose}-account-icon`, { className: css.walletNameBlockSvg })}
                        </div>
                        <p className={css.walletName}>{wallet?.name}</p>
                    </div>
                    <div className={css.walletHeadButtons}>
                        {/* лише для першого гаманця виводимо віджет зміни валюти */}
                        {index === 0 ? (
                            <div>
                                <FormRadio
                                    attribute='currency'
                                    options={currenciesAsOptions}
                                    compStyle={{
                                        wrapper: {
                                            className: css.walletRadioSwitch
                                        },
                                        togglerBackground: {
                                            className: css.walletRadioSwitchTogglerBg
                                        },
                                        togglerElement: {
                                            className: css.togglerElement
                                        },
                                        togglerElementActive: {
                                            className: css.togglerElementActive
                                        },
                                        togglerElementText: {
                                            className: css.togglerElementText
                                        }
                                    }}
                                    setFormData={(k, v) => setRadioSwitcher(v)}
                                    value={radioSwitcher}
                                />
                            </div>
                        ) : null}
                        {/* йдемо до транзакцій гаманця */}
                        <div
                            onClick={() => {
                                navigateV2(
                                    `/wallets/finance-documents?filter[account][credit]=${wallet.id}&filter[account][debit]=${wallet.id}`
                                );
                            }}
                            className={classNames(css.walletCopyBtn, 'grow', customCss?.walletCopyBtn)}
                        >
                            {svgSprite('copy', { className: css.walletCopySvg })}
                        </div>
                    </div>
                </div>
                <div className={css.walletBalance}>
                    <p className={css.walletBalanceValue}>
                        <span className={css.walletBalanceBig}>{(+number).toLocaleString()}</span>.
                        <span className={css.walletBalanceSmall}>{remainder.toLocaleString()}</span>
                    </p>
                    <p className={css.walletBalanceCurrency}>{wallet?.currency.code || wallet?.currency?.symbol}</p>
                </div>
                {wallet?.purpose != 'gift' ? (
                    <div className={css.walletWithdrawal}>
                        <p className={css.walletWithdrawalLabel}>
                            <T textName='expected_for_withdrawal' defaultStr='Ожидается на вывод' />:
                        </p>
                        <p className={css.walletWithdrawalValue}>
                            <span>{wallet?.withdrawal_amount} </span>
                            <span>{wallet?.currency?.code || wallet.currency?.symbol}</span>
                        </p>
                    </div>
                ) : null}

                {/* TODO */}
                {wallet?.purpose != 'gift' ? (
                    isWalletsPage ? (
                        <div className={classNames(css.walletWithdrawal, css.walletExchangeRate)}>
                            <p className={css.walletWithdrawalLabel}>
                                <T textName='course_for_withdrawal' defaultStr='Курс на вывод' />:
                            </p>
                            {meta ? (
                                <p className={css.walletWithdrawalValue}>
                                    <span>{`1 PV = ${meta?.rate?.value?.toLocaleString()} `}</span>
                                    <span>{meta?.rate?.currency?.code}</span>
                                </p>
                            ) : null}
                        </div>
                    ) : null
                ) : null}
                <div
                    className={classNames(css.walletButtons, { [css.dn]: number_of_buttons === 0 || 1 })}
                    style={{
                        gridTemplateColumns: `repeat(${number_of_buttons}, 1fr)`
                    }}
                >
                    {wallet.replenishment && (
                        <div
                            className={classNames(css.walletButton)}
                            onClick={(e) => {
                                e.stopPropagation();
                                navigateV2(`/wallets/inmoney/${wallet.id}`);
                            }}
                        >
                            <span className={css.walletButtonText}>
                                {t('wallet-tooltip-1', 'Пополнить', '/office', translation)}
                            </span>
                        </div>
                    )}
                    {wallet.withdrawal ? (
                        <div className={classNames(css.walletButton)} onClick={outMoneyHandler}>
                            <span className={css.walletButtonText}>
                                {t('wallet-tooltip-2', 'Вывести', '/office', translation)}
                            </span>
                        </div>
                    ) : null}
                    {wallet.transfer_to_user || wallet.own_transfer_accounts?.length ? (
                        <div
                            className={classNames(css.walletButton)}
                            onClick={(e) => {
                                e.stopPropagation();
                                navigateV2(`/wallets/transfermoney/${wallet.id}`);
                            }}
                        >
                            <span className={css.walletButtonText}>
                                {t('wallet-tooltip-3-new', 'Перевод', '/office', translation)}
                            </span>
                        </div>
                    ) : null}
                </div>
                {wallet?.purpose != 'gift'
                    ? filteredCurrencyAccounts?.length
                        ? filteredCurrencyAccounts?.map((account) => (
                              <CurrencyItem
                                  radioSwitcher={radioSwitcher}
                                  wallet={wallet}
                                  outMoneyHandler={outMoneyHandler}
                                  key={account?.id}
                                  account={account}
                              />
                          ))
                        : null
                    : null}
                {!isLast ? <div className={css.walletLine}></div> : null}
            </div>
            {verifyModal ? <VerifyModal closeHandler={() => showVerifyModal(false)} /> : null}
        </>
    );
}
